export const lightTheme = {
  primary: '#FFFFFF',
  secondary: '#ff00bf',
  lightgray: '#002A52',
  themewhite: '#000000',
};
